import EditIconMUI from "@mui/icons-material/Edit";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import MultiFormatResizeMenu from "./MultiFormatResizeMenu";
import {
  EDIT_WITH_CANVA,
  EDIT_WITH_IA,
  ANIMATE_IMAGE_WITH_AI,
} from "../../i18n/keysTranslations";

const FormatMenuButton = ({
  url,
  variant = "full",
  onResizeFormat = () => {},
  onEditWithCanva = () => {},
  onAnimateImage = () => {},
  onEditWithIA = () => {},
  showAnimate = true,
  hideResizeOptions = false,
  sx = {},
  iconColor = "white",
  mode = "icon",
  disabled = false,
  loading = false,
  textButton = "",
  colorButton = "primary",
}) => {
  const additionalMenuItems =
    variant === "full"
      ? [
          {
            label: EDIT_WITH_CANVA,
            icon: <EditIconMUI sx={{ fontSize: 16, mr: 1 }} />,
            onClick: onEditWithCanva,
          },
          {
            label: EDIT_WITH_IA,
            icon: <AutoAwesomeIcon sx={{ fontSize: 16, mr: 1 }} />,
            onClick: onEditWithIA,
          },
          ...(showAnimate
            ? [
                {
                  label: ANIMATE_IMAGE_WITH_AI,
                  icon: <AutoAwesomeIcon sx={{ fontSize: 16, mr: 1 }} />,
                  onClick: onAnimateImage,
                },
              ]
            : []),
        ]
      : [];

  return (
    <MultiFormatResizeMenu
      url={url}
      variant={variant}
      onResizeFormat={onResizeFormat}
      additionalMenuItems={additionalMenuItems}
      hideResizeOptions={hideResizeOptions}
      disabled={disabled}
      loading={loading}
      sx={sx}
      iconColor={iconColor}
      mode={mode}
      textButton={textButton}
      colorButton={colorButton}
    />
  );
};

export default FormatMenuButton;
